import firebase from 'firebase'
import React, { Component } from 'react'
import { AppHeader } from '../components/AppHeader'
import { IRoom } from '../models'
import { Link } from 'react-router-dom'
import CopyToClipboard from 'react-copy-to-clipboard';
import { firestore } from '../firebase';

const style = {
  marginTop: '100px'
};

type PageState = {
  room: IRoom | null,
  roomName: string,
  startByRoomOwner: boolean,
  copied: boolean,
}

const initialState = (): PageState => ({
  room: null,
  roomName: '',
  startByRoomOwner: true,
  copied: false,
})

export class CreateRoomPage extends Component<{}, PageState> {
  state = initialState()

  async submit() {
    const user = firebase.auth().currentUser
    if (!user) {
      throw Error('なぜかuserが取れませんでした')
    }

    const docRef = await firestore.collection('room').add({
      roomName: this.state.roomName,
      startByRoomOwner: this.state.startByRoomOwner,
      roomOwnerId: user.uid,
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    })
    const room = await docRef.get()
    const data = room.data() as any
    this.setState({
      room: {
        ...data,
        id: docRef.id
      }
    })
  }

  render() {
    if (!this.state.room) {
      return (
        <div className="container">
          <AppHeader />
          <p>Create Room</p>
          <div className="container" style={style}>
            <div className="field">
              <div className="control">
                <input
                  className="input"
                  type="text"
                  placeholder="room name"
                  onChange={(e) => this.setState({ roomName: e.target.value })}
                  value={this.state.roomName}
                />
              </div>
            </div>
            <div className="field">
              <div className="control">
                <label className="checkbox">
                  <input
                    type="checkbox"
                    onChange={(e) => this.setState({ startByRoomOwner: !this.state.startByRoomOwner })}
                    checked={this.state.startByRoomOwner}
                  />
                  Do you want get first hand?
                </label>
              </div>
            </div>
            <div className="field">
              <div className="control">
                <button className="button is-link" onClick={() => this.submit()}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className="container">
        <AppHeader />
        <div className="container" style={style}>
          <p>Let's share your room link!</p>
          <br />
          <p>{`${window.location.protocol}//${window.location.host}/battle/${this.state.room.id}`}</p>
          <br />
          <CopyToClipboard text={`${window.location.protocol}//${window.location.host}/battle/${this.state.room.id}`}
            onCopy={() => this.setState({ copied: true })}>
            <button>Copy</button>
          </CopyToClipboard>
          <br />

          {this.state.copied ? <span style={{ color: 'red' }}>Copied.</span> : null}
          <br />
          <Link className="button is-primary" to={`/battle/${this.state.room.id}`}>
            <strong>Ready</strong>
          </Link>
        </div>
      </div>
    )
  }
}
